<template>
  <div class="feed-filter">
    {{$t('feed.SortTitle')}}:
    <span class="feed-filter__item" @click="setFilter">
      {{filter.items[filter.current].title}} <i :class="`el-icon-${filter.current}`"></i>
    </span>
  </div>
</template>

<script>
  export default {
    name: "FeedFilter",
    props: {
      user: {
        type: String
      },
    },
    data() {
      return {
        filter: Object.assign({}, this.$t('feed.filter'))
      };
    },
    methods: {
      setFilter() {
        this.filter.current = this.filter.current ==='bottom' ? 'top' : 'bottom';
        this.$emit("onFilter", {filter: this.filter.current , user: this.user});
      },
    }
  };
</script>

<style>
  .feed-filter {
    display: flex;
    margin-bottom: 15px;
  }
  .feed-filter__item {
    display: block;
    margin-left: 10px;
    cursor: pointer;
    font-weight: 700;
  }
</style>
